
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Logo from '../assets/logo.png'

function VentanaModal({show, handleClose, msg, boton, pregunta}) {
  const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;</>;

  const renderList = msg.map((item, index) => 
    <div key={index}>{item}</div>
  );

  const respuesta =()=>{
    handleClose(true)
    pregunta()
  }

  return (<>
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <img src={Logo} className='img-fluid' width='40px' height='120px' alt='logo'/>
        <Modal.Title>{tab}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul>{renderList}</ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
        {boton!==undefined && boton!=='' &&
          <Button variant="primary" onClick={respuesta}>
            {boton}
          </Button>
        }
      </Modal.Footer>
    </Modal>
  </>
  );
}

export default VentanaModal